const getCurrentRelativeUrl = () => `${window.location.pathname}${window.location.search}${window.location.hash}`

export const buildBindRedirectUrl = (redirect = getCurrentRelativeUrl()) =>
  `/bind?redirect=${encodeURIComponent(redirect)}`

export const redirectToBindIfNeeded = (phone?: string | null, redirect?: string) => {
  if ((phone || '').trim()) {
    return false
  }
  window.location.href = buildBindRedirectUrl(redirect)
  return true
}
